(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gokwik-cart-offer-summary"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.seeGoKwikCartOffer) {
      window.seeGoKwikCartOffer.refresh();
      return;
    }

    var requestNumber = 0;
    var refreshTimer;
    var offers = [
      {
        unitPrice: 140700,
        savings: 31500,
        note: 'Buy 2 eligible kurta sets for ₹2,499. The offer will be applied automatically at checkout.'
      },
      {
        unitPrice: 118900,
        savings: 67900,
        note: 'Buy 2 eligible kurtas for ₹1,699. The offer will be applied automatically at checkout.'
      },
      {
        productType: 'Short Kurta',
        bundleQuantity: 2,
        bundlePrice: 99900,
        note: 'Buy 2 eligible short kurtas for ₹999. The offer will be applied automatically at checkout.'
      }
    ];

    function formatInr(cents) {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0
      }).format((Number(cents) || 0) / 100);
    }

    function hideOffer() {
      document.querySelectorAll('[data-gokwik-cart-offer-summary]').forEach(function (container) {
        container.hidden = true;
      });
    }

    function renderOffer(cartData) {
      var activeOffers = offers.map(function (offer) {
        if (offer.productType) {
          var eligibleUnitPrices = [];

          (cartData.items || []).forEach(function (item) {
            var isEligible = item.product_type === offer.productType
              && Number(item.original_price) === Number(item.final_price);
            var quantity = isEligible ? Number(item.quantity) || 0 : 0;

            for (var unit = 0; unit < quantity; unit += 1) {
              eligibleUnitPrices.push(Number(item.original_price));
            }
          });

          eligibleUnitPrices.sort(function (a, b) { return b - a; });
          var bundleCount = Math.floor(eligibleUnitPrices.length / offer.bundleQuantity);
          if (bundleCount < 1) return null;

          var offerSavings = 0;
          for (var bundle = 0; bundle < bundleCount; bundle += 1) {
            var bundleSubtotal = 0;
            for (var index = 0; index < offer.bundleQuantity; index += 1) {
              bundleSubtotal += eligibleUnitPrices[(bundle * offer.bundleQuantity) + index];
            }
            offerSavings += Math.max(0, bundleSubtotal - offer.bundlePrice);
          }

          return { savings: offerSavings, note: offer.note };
        }

        var eligibleQuantity = (cartData.items || []).reduce(function (quantity, item) {
          var isEligible = Number(item.original_price) === offer.unitPrice
            && Number(item.final_price) === offer.unitPrice;
          return quantity + (isEligible ? Number(item.quantity) || 0 : 0);
        }, 0);

        return eligibleQuantity >= 2
          ? { savings: offer.savings, note: offer.note }
          : null;
      }).filter(Boolean);

      if (cartData.currency !== 'INR' || activeOffers.length === 0) {
        hideOffer();
        return;
      }

      var totalSavings = activeOffers.reduce(function (sum, offer) {
        return sum + offer.savings;
      }, 0);
      var estimatedTotal = Math.max(0, Number(cartData.total_price) - totalSavings);
      var offerNote = activeOffers.map(function (offer) {
        return offer.note;
      }).join(' ');

      document.querySelectorAll('[data-gokwik-cart-offer-summary]').forEach(function (container) {
        var savings = container.querySelector('[data-gokwik-offer-savings]');
        var total = container.querySelector('[data-gokwik-offer-total]');
        var note = container.querySelector('[data-gokwik-offer-note]');
        if (savings) savings.textContent = '-' + formatInr(totalSavings);
        if (total) total.textContent = formatInr(estimatedTotal);
        if (note) note.textContent = offerNote;
        container.hidden = false;
      });
    }

    function refresh() {
      var currentRequest = ++requestNumber;
      fetch(window.Shopify.routes.root + 'cart.js', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to read cart.');
          return response.json();
        })
        .then(function (cartData) {
          if (currentRequest === requestNumber) renderOffer(cartData);
        })
        .catch(function () {
          if (currentRequest === requestNumber) hideOffer();
        });
    }

    function scheduleRefresh() {
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(refresh, 120);
    }

    window.seeGoKwikCartOffer = { refresh: refresh };
    document.addEventListener('cart:updated', scheduleRefresh);
    document.addEventListener('cart:build', scheduleRefresh);
    document.addEventListener('cart:refresh', scheduleRefresh);
    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches('.cart__item .js-qty__num')) scheduleRefresh();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refresh);
    } else {
      refresh();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
